<template>
  <div>
    <v-container grid-list-md>

      <div class="crx-header">
        <span class="headline">Developer Docs</span>
      </div>

      <v-layout column>
        
        <a class="todo-link" target="_blank" href="https://www.uxpin.com/studio/blog/19-best-practices-for-faster-ui-mockups/">https://www.uxpin.com/studio/blog/19-best-practices-for-faster-ui-mockups/</a><br>

        <a class="todo-link" target="_blank" href="https://docs.microsoft.com/en-us/sql/relational-databases/tables/creating-a-system-versioned-temporal-table?view=sql-server-2017">https://docs.microsoft.com/en-us/sql/relational-databases/tables/creating-a-system-versioned-temporal-table?view=sql-server-2017</a><br>

        <v-expansion-panel popout>
          <v-expansion-panel-content>
            <div slot="header" class="link-header">RSync</div>
            <v-card>
              <v-card-text>
                <a class="todo-link" target="_blank" href="https://serverfault.com/questions/310337/using-rsync-from-msysgit-for-binary-files">Installation on Windows (Git Bash)</a><br>
                <a class="todo-link" target="_blank" href="https://www.tecmint.com/rsync-local-remote-file-synchronization-commands/">Common commands</a><br>
                <code-block>
                  rsync -avzhe ssh newb@corex-db.com:/home/newb/dbbackup/ /c/CorexMariaBackup
                </code-block>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel popout>
          <v-expansion-panel-content>
            <div slot="header" class="link-header">Maria DB</div>
            <v-card>
              <v-card-text>
                <a class="todo-link" target="_blank" href="https://mariadb.com/kb/en/library/system-versioned-tables/">System versioning</a><br>

                <a class="todo-link" target="_blank" href="https://stackoverflow.com/questions/4962342/mariadb-on-windows-what-is-this-error-when-trying-to-start-the-database-engine">install on windows</a><br>

                <a class="todo-link" target="_blank" href="https://www.tecmint.com/upgrade-mariadb-5-5-to-10-centos-rhel-debian-ubuntu/">install on Centos</a><br>

                <a class="todo-link" target="_blank" href="https://mariadb.com/kb/en/library/mariabackup-overview/">Backing up a system versioned table</a><br>

                <a class="todo-link" target="_blank" href="https://mariadb.com/resources/blog/automatic-data-versioning-in-mariadb-server-10-3/">ROW START, ROW END</a><br>

                
                <code-block>
                  mysql_install_db --datadir="C:\Program Files\MariaDB 10.3\data
                </code-block>

                <code-block>
                  SELECT t1.*, ROW_END < NOW() AS deleted FROM corexdb.inventory_definitions FOR SYSTEM_TIME ALL t1 WHERE t1.ROW_START = (SELECT MAX(t2.ROW_START) FROM corexdb.inventory_definitions FOR SYSTEM_TIME ALL t2 WHERE t2.id = t1.id)
                </code-block>

                <code-block>
                  ALTER TABLE t ADD SYSTEM VERSIONING
                </code-block>

                <!-- EXPORTING A TABLE -->
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <div slot="header" class="link-header">Backup Process</div>
                    <v-card>
                      <v-card-text>
                        <a class="todo-link" target="_blank" href="https://mariadb.com/kb/en/library/full-backup-and-restore-with-mariabackup/">Full Backup and Restore with Mariabackup</a><br>
                        
                        <!-- timeline -->
                        <v-timeline
                        align-top
                        dense>
                          <v-timeline-item
                            color="pink"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>1. Export</strong>
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Windows</div>
                                    <code-block>
                                      mariabackup --backup --target-dir="C:/CorexMariaBackup/" --user newb --password {{ MYSQL_PASSWORD }}
                                    </code-block>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Centos 7</div>
                                    <code-block>
                                      mariabackup --backup --target-dir="/home/newb/dbbackup" --user newb --password {{ MYSQL_PASSWORD }}
                                    </code-block>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                          <v-timeline-item
                            color="green"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>2. Prepare destination db</strong>
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Windows</div>
                                    <code-block>
                                      mariabackup --prepare --target-dir="C:/CorexMariaBackup/" --user newb --password {{ MYSQL_PASSWORD }}
                                    </code-block>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Centos 7</div>
                                    <code-block>
                                      mariabackup --prepare --target-dir="/home/newb/dbbackup" --user newb --password {{ MYSQL_PASSWORD }}
                                    </code-block>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                          <v-timeline-item
                            color="green"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>3. Clear directories</strong>
                                First, stop the MariaDB Server.
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Windows</div>
                                    <code-block>
                                      NET STOP MySQL
                                    </code-block>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <div class="font-weight-bold">Centos 7</div>
                                    <code-block>
                                      systemctl stop mariadb
                                    </code-block>
                                  </v-flex>
                                </v-layout>
                                <div>
                                  Then, ensure that the datadir is empty.
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                          <v-timeline-item
                            color="green"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>4. Copy back</strong>
                                <code-block>
                                  mariabackup --copy-back --target-dir="C:/CorexMariaBackup/" --user newb --password {{ MYSQL_PASSWORD }}
                                </code-block>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                          <v-timeline-item
                            color="green"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>5. Temporary hack</strong>
                                <code-block>
                                  mysql_install_db --datadir="C:\Program Files\MariaDB 10.3\data
                                </code-block>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                          <v-timeline-item
                            color="green"
                            small>
                            <v-layout pt-3>
                              <v-flex>
                                <strong>6. Restart</strong>
                                <code-block>
                                  NET START MySQL
                                </code-block>
                              </v-flex>
                            </v-layout>
                          </v-timeline-item>
                        </v-timeline>

                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- END EXPORTING A TABLE -->

                <!-- Foreign keys -->
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <div slot="header" class="link-header">Foreign Keys</div>
                    <div>
                        <code-block>
                          ALTER TABLE corexdb.inventory ADD CONSTRAINT FOREIGN KEY (inventory_item_id) REFERENCES corexdb.inventory_definitions (id)
                        </code-block>
                        <code-block>
                          SELECT * FROM corexdb.inventory I WHERE NOT EXISTS(SELECT * FROM corexdb.inventory_definitions D WHERE I.inventory_item_id = D.id)
                        </code-block>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Foreign keys -->

              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <a class="todo-link" target="_blank" href="https://dribbble.com/uixninja">UIXNINJA - Dribble</a><br>

        <a class="todo-link" target="_blank" href="https://laracasts.com/discuss/channels/vue/pass-multiple-parameters-to-atchange">Laracasts awesome website</a><br>

        <a class="todo-link" target="_blank" href="https://www.nngroup.com/topic/mobile-and-tablet-design/">www.nngroup.com (UX Principles)</a><br>

        <a class="todo-link" target="_blank" href="https://uxdesign.cc/design-better-data-tables-4ecc99d23356">Data table design</a><br>

        <a class="todo-link" target="_blank" href="https://colorlib.com/etc/tb/Table_Fixed_Column/index.html">Purple gradient table</a><br>

        <a class="todo-link" target="_blank" href="https://akryum.github.io/vue-virtual-scroller/#/">Vue virtual scroller</a><br>

        <a class="todo-link" target="_blank" href="https://markus.oberlehner.net/blog/vue-router-page-transitions/">Vue transitions</a><br>

        <a class="todo-link" target="_blank" href="https://snipcart.com/blog/vuejs-transitions-animations">Vue animations (including svg)</a><br>

        <v-layout wrap>

          <v-flex xs12 sm6>

            <v-card class="mb-2 crx-section-card">
              <v-card-text>
                <div class="blue-grey--text subheading mt-4 mb-2">
                  FUNCTIONAL
                </div>

                <div class="blue-grey--text subheading mt-4 mb-2">
                  High priority functional
                </div>
                <ul>
                  <li class="blue--text">Fix production, add a place for samples.</li>
                  <li class="blue--text">Cost per unit in deliveries, then in pro formas, then do sales.</li>
                  <li class="blue--text">production freezing or stock removal (especially for packaging)</li>
                  <li class="red--text">deduct packaging from stock immediately production stage 1</li>
                  <li>Make production automatically select inputs</li>
                  <li>Pro formas</li>
                </ul>
              </v-card-text>
            </v-card>

            <v-card class="mb-2 crx-section-card">
              <v-card-text>
                <div class="blue-grey--text subheading mt-4 mb-2">
                  Low priority functional
                </div>
                <ul>
                  <li>DONE</li>
                  <li>production_raw_material_inputs stock_deducted column is no longer needed?</li>
                </ul>
              </v-card-text>
            </v-card>

          </v-flex>

          <v-flex xs12 sm6>
            <v-card class="mb-2 crx-section-card">
              <v-card-text>

                <div class="subheading mt-4 mb-2 font-weight-bold">
                  <span class="teal--text">VISUAL</span>
                </div>

                <div class="blue-grey--text subheading mt-4 mb-2">
                  High priority visual
                </div>
                <ul>
                  <li>Show flags on inventory definition (raw material, finished product, etc)</li>
                  <li>Select boxes border</li>
                </ul>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>

        <div class="blue-grey--text subheading mt-4 mb-2">
          Links
        </div>

        <ul>
          <li><a href="https://dribbble.com/search?q=dashx">dashx</a></li>
          <li><a href="http://www.uimotionkit.io/">Animation - Motion Kit</a></li>
          <li><a href="https://dribbble.com/shots/4815423-Factory-Activity-Dashboard">dark</a></li>
          <li><a href="http://hejx.space/vddl-demo/#/nested">Drag and drop vue</a></li>
          <li><a href="https://dribbble.com/shots/3882136-Xcite-l-Travel-Experience">Drag and drop vue</a></li>
        </ul>

      </v-layout>

    </v-container>

  </div>
</template>

<script>
import CodeBlock from './components/code-block'

export default {
  components: {
    'code-block': CodeBlock
  },
  data () {
    return {
      MYSQL_PASSWORD: process.env.VUE_APP_MYSQL_PASSWORD
    }
  }
}
</script>

<style scoped>
.todo-link {
  text-decoration: none;
  color: #1E88E5;
}
.todo-link:hover {
  color: indianred;
}
.link-header {
  font-weight: bold;
  font-size: 1.2rem;
}
.code-block {
  background: #f3f6f8;
  padding: 10px;
  border: thin solid rgba(0,0,0,0.2);
  border-radius: 4px;
}
</style>
